import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import { Eye, EyeOff } from "lucide-react";

const PasswordToggle = ({
  value,
  onChange,
  placeholder = "Inserisci la password",
  autoComplete = "new-password",
  isValid,
  isInvalid,
  onPaste,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="login-password-wrapper">
      <Form.Control
        required
        type={showPassword ? "text" : "password"}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        autoComplete={autoComplete}
        className="login-password-input"
        isValid={isValid}
        isInvalid={isInvalid}
        onPaste={onPaste}
      />
      <button
        type="button"
        className="login-password-toggle"
        onClick={() => setShowPassword((visible) => !visible)}
        aria-label={showPassword ? "Nascondi password" : "Mostra password"}
      >
        {showPassword ? (
          <EyeOff size={20} strokeWidth={1.75} aria-hidden="true" />
        ) : (
          <Eye size={20} strokeWidth={1.75} aria-hidden="true" />
        )}
      </button>
    </div>
  );
};

export default PasswordToggle;
